const SOURCE_COLORS: Record<string, string> = {
  playground: 'var(--color-primary-500)',
  api: '#6D5BD0',
  batch: 'var(--color-green-500)',
};
const FALLBACK_COLORS = ['#0EA5A0', '#C89116', '#3B5BDB'];

export interface SourceSlice { label: string; value: number; pct: number; color: string; }

export function sourceSlices(bySource: Record<string, number> | null | undefined): SourceSlice[] {
  const entries = Object.entries(bySource ?? {});
  const total = entries.reduce((sum, [, v]) => sum + v, 0) || 1;
  return entries
    .sort((a, b) => b[1] - a[1])
    .map(([label, value], i) => ({
      label,
      value,
      pct: Math.round((value / total) * 100),
      color: SOURCE_COLORS[label] ?? FALLBACK_COLORS[i % FALLBACK_COLORS.length],
    }));
}

export function sourceSlicesLabel(slices: SourceSlice[]): string {
  return 'Requests by source: ' + slices.map(s => `${s.label} ${s.pct}%`).join(', ');
}
